import '../css/app.css';

import { createInertiaApp } from '@inertiajs/vue3';
// import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
// import { createApp, h } from 'vue';
import { createSSRApp, h } from 'vue'
import { ZiggyVue } from '../../vendor/tightenco/ziggy/src/js';
import { createPinia } from 'pinia'
import VueFeather from 'vue-feather';
import VueObserveVisibility from 'vue3-observe-visibility'


const appName = import.meta.env.VITE_APP_NAME || 'Valerie Hird';
import Layout from './layouts/Layout.vue'

createInertiaApp({
    title: (title) => `${title} - Valerie Hird`,
    resolve: name => {
            const pages = import.meta.glob('./pages/**/*.vue', { eager: true })
            let page = pages[`./pages/${name}.vue`]
            page.default.layout = page?.default?.layout || Layout
            return page
          },
    // resolve: (name) =>
    //     resolvePageComponent(
    //         `./Pages/${name}.vue`,
    //         import.meta.glob('./Pages/**/*.vue'),
    //     ),
    setup({ el, App, props, plugin }) {
        const pinia = createPinia();
        return createSSRApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue)
            .use(pinia)
            .use(VueObserveVisibility)
            .component(VueFeather.name, VueFeather)
            .mount(el);
    },
    progress: {
        delay: 250,
        color: '#4B5563',
    },
});


